import { render, staticRenderFns } from "./videos-list.vue?vue&type=template&id=1bf7728a&"
import script from "./videos-list.vue?vue&type=script&lang=js&"
export * from "./videos-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports